module.exports = __webpack_public_path__ + "static/media/bg.ee746b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.png
// module id = 236
// module chunks = 0